import createRequestSlice, { requestInitialState } from 'redux/request/reducer';
import get from 'lodash/get';

export const PREFIX = 'buildings.projectList';

export const initialState = {
  ...requestInitialState,
  data: [],
  page: 1,
  perPage: 25,
  total: 0,
  q: '',
  isLoading: false,
  hasError: false,
};

const projectListSlice = createRequestSlice({
  name: PREFIX,
  initialState,
  reducers: {
    request(state) {
      return {
        ...state,
        hasError: false,
        isLoading: true,
      };
    },
    failure(state) {
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };
    },
    fetch(state, { payload }) {
      const { data, endUserFileUrl, glassCheckFileUrl, ...rest } = payload;
      return {
        ...state,
        ...rest,
        data: get(payload, 'data', []) || [],
        endUserFileUrl,
        glassCheckFileUrl,
        hasError: false,
        isLoading: false,
      };
    },
    setFilter(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const actions = { ...projectListSlice.actions };
export const requests = { ...projectListSlice.requests };

export default projectListSlice.reducer;
